export const fileSystemUtils = {
    getFileAsBase64: (file: File): Promise<string> =>
        new Promise(function (resolve, reject) {
            const reader = new FileReader();
            reader.onerror = reject;

            reader.onload = function () {
                const buffer = reader.result as ArrayBuffer;
                const base64 = new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), '');
                resolve(btoa(base64));
            };
            reader.readAsArrayBuffer(file);
        })
};
